const index = [
  {
    title: 'howItWorks:accordion.howItWorks.questionOne',
    content: `howItWorks:accordion.howItWorks.answerOne`,
  },
  {
    title: 'howItWorks:accordion.howItWorks.questionTwo',
    content: `howItWorks:accordion.howItWorks.answerTwo`,
  },
  {
    title: 'howItWorks:accordion.howItWorks.questionThree',
    content: `howItWorks:accordion.howItWorks.answerThree`,
  },
  {
    title: 'howItWorks:accordion.howItWorks.questionFour',
    content: `howItWorks:accordion.howItWorks.answerFour`,
  },
  {
    title: 'howItWorks:accordion.howItWorks.questionFive',
    content: `howItWorks:accordion.howItWorks.answerFive`,
  },
  {
    title: 'howItWorks:accordion.howItWorks.questionSix',
    content: `howItWorks:accordion.howItWorks.answerSix`,
  },
  {
    title: 'howItWorks:accordion.howItWorks.questionSeven',
    content: `howItWorks:accordion.howItWorks.answerSeven`,
  },
];

const howToUse = [
  {
    title: 'howItWorks:accordion.howToUse.questionOne',
    content: `howItWorks:accordion.howToUse.answerOne`,
  },
  {
    title: 'howItWorks:accordion.howToUse.questionTwo',
    content: `howItWorks:accordion.howToUse.answerTwo`,
  },
  {
    title: 'howItWorks:accordion.howToUse.questionThree',
    content: `howItWorks:accordion.howToUse.answerThree`,
  },
  {
    title: 'howItWorks:accordion.howToUse.questionFour',
    content: `howItWorks:accordion.howToUse.answerFour`,
  },
  {
    title: 'howItWorks:accordion.howToUse.questionFive',
    content: `howItWorks:accordion.howToUse.answerFive`,
  },
  {
    title: 'howItWorks:accordion.howToUse.questionSix',
    content: `howItWorks:accordion.howToUse.answerSix`,
  },
  {
    title: 'howItWorks:accordion.howToUse.questionSeven',
    content: `howItWorks:accordion.howToUse.answerSeven`,
  },
];

const howToUpload = [
  {
    title: 'howItWorks:accordion.howToUpload.questionOne',
    content: `howItWorks:accordion.howToUpload.answerOne`,
  },
  {
    title: 'howItWorks:accordion.howToUpload.questionTwo',
    content: `howItWorks:accordion.howToUpload.answerTwo`,
  },
  {
    title: 'howItWorks:accordion.howToUpload.questionThree',
    content: `howItWorks:accordion.howToUpload.answerThree`,
  },
  {
    title: 'howItWorks:accordion.howToUpload.questionFour',
    content: `howItWorks:accordion.howToUpload.answerFour`,
  },
  {
    title: 'howItWorks:accordion.howToUpload.questionFive',
    content: `howItWorks:accordion.howToUpload.answerFive`,
  },
];

const getFeedback = [
  {
    title: 'howItWorks:accordion.getFeedback.questionOne',
    content: `howItWorks:accordion.getFeedback.answerOne`,
  },
  {
    title: 'howItWorks:accordion.getFeedback.questionTwo',
    content: `howItWorks:accordion.getFeedback.answerTwo`,
  },
  {
    title: 'howItWorks:accordion.getFeedback.questionThree',
    content: `howItWorks:accordion.getFeedback.answerThree`,
  },
  {
    title: 'howItWorks:accordion.getFeedback.questionFour',
    content: `howItWorks:accordion.getFeedback.answerFour`,
  },
];

const releasingMusic = [
  {
    title: 'howItWorks:accordion.releasingMusic.questionOne',
    content: `howItWorks:accordion.releasingMusic.answerOne`,
  },
  {
    title: 'howItWorks:accordion.releasingMusic.questionTwo',
    content: `howItWorks:accordion.releasingMusic.answerTwo`,
  },
  {
    title: 'howItWorks:accordion.releasingMusic.questionThree',
    content: `howItWorks:accordion.releasingMusic.answerThree`,
  },
  {
    title: 'howItWorks:accordion.releasingMusic.questionFour',
    content: `howItWorks:accordion.releasingMusic.answerFour`,
  },
  {
    title: 'howItWorks:accordion.releasingMusic.questionFive',
    content: `howItWorks:accordion.releasingMusic.answerFive`,
  },
];

const joinContests = [
  {
    title: 'howItWorks:accordion.joinContests.questionOne',
    content: `howItWorks:accordion.joinContests.answerOne`,
  },
  {
    title: 'howItWorks:accordion.joinContests.questionTwo',
    content: `howItWorks:accordion.joinContests.answerTwo`,
  },
  {
    title: 'howItWorks:accordion.joinContests.questionThree',
    content: `howItWorks:accordion.joinContests.answerThree`,
  },
];

const whatAreVcoins = [
  {
    title: 'howItWorks:accordion.whatAreVcoins.questionOne',
    content: `howItWorks:accordion.whatAreVcoins.answerOne`,
  },
  {
    title: 'howItWorks:accordion.whatAreVcoins.questionTwo',
    content: `howItWorks:accordion.whatAreVcoins.answerTwo`,
  },
  {
    title: 'howItWorks:accordion.whatAreVcoins.questionThree',
    content: `howItWorks:accordion.whatAreVcoins.answerThree`,
  },
  {
    title: 'howItWorks:accordion.whatAreVcoins.questionFour',
    content: `howItWorks:accordion.whatAreVcoins.answerFour`,
  },
];

const statistics = [
  {
    title: 'howItWorks:accordion.statistics.questionOne',
    content: `howItWorks:accordion.statistics.answerOne`,
  },
  {
    title: 'howItWorks:accordion.statistics.questionTwo',
    content: `howItWorks:accordion.statistics.answerTwo`,
  },
  {
    title: 'howItWorks:accordion.statistics.questionThree',
    content: `howItWorks:accordion.statistics.answerThree`,
  },
  {
    title: 'howItWorks:accordion.statistics.questionFour',
    content: `howItWorks:accordion.statistics.answerFour`,
  },
  {
    title: 'howItWorks:accordion.statistics.questionFive',
    content: `howItWorks:accordion.statistics.answerFive`,
  },
  {
    title: 'howItWorks:accordion.statistics.questionSix',
    content: `howItWorks:accordion.statistics.answerSix`,
  },
];

export interface Page {
  title: string;
  content: string;
}

export {
  index,
  howToUse,
  howToUpload,
  whatAreVcoins,
  getFeedback,
  releasingMusic,
  joinContests,
  statistics,
};
